import {SourceId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const source = typedQuery(["tprm", "source", param<SourceId>("sourceId")], async sourceId => {
  return await api.tprm.sources.get(sourceId);
});

export const sourceVersions = typedQuery(["tprm", "sourceVersions", param<SourceId>("sourceId")], async sourceId => {
  return await api.tprm.sources.versions(sourceId);
});
